{
  "name": "bia-portal",
  "version": "1.0.8.231-1-dev",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/akveo/ngx-admin.git"
  },
  "bugs": {
    "url": "https://github.com/akveo/ngx-admin/issues"
  },
  "scripts": {
    "ng": "ng",
    "conventional-changelog": "conventional-changelog",
    "start": "ng serve",
    "start:prodcaixa": "ng serve --configuration prodcaixa",
    "start:proxy": "ng serve --configuration proxy",
    "start:test": "ng serve --configuration test",
    "start:local": "ng serve --configuration local",
    "start:localIIS": "ng serve --configuration localIIS",
    "build": "ng build",
    "build:dev": "ng build --configuration=dev",
    "build:test": "ng build --configuration=test",
    "build:prod": "npm run build -- --configuration=production",
    "build:prodcaixa": "npm run build -- --configuration=prodcaixa",
    "test": "ng test",
    "test:coverage": "rimraf coverage && npm run test -- --code-coverage",
    "lint": "ng lint",
    "lint:fix": "ng lint bia-portal --fix",
    "lint:styles": "stylelint ./src/**/*.scss",
    "lint:ci": "npm run lint && npm run lint:styles",
    "e2e": "ng e2e",
    "ct": "ng run bia-portal:ct",
    "docs": "compodoc -p tsconfig.app.json -d docs",
    "docs:serve": "compodoc -p tsconfig.app.json -d docs -s",
    "prepush_disabled": "npm run lint:ci",
    "release:changelog": "npm run conventional-changelog -- -p angular -i CHANGELOG.md -s",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run"
  },
  "dependencies": {
    "@angular/animations": "^21.2.15",
    "@angular/cdk": "21.0.6",
    "@angular/common": "^21.2.15",
    "@angular/compiler": "^21.2.15",
    "@angular/core": "^21.2.15",
    "@angular/forms": "^21.2.15",
    "@angular/localize": "^21.2.15",
    "@angular/platform-browser": "^21.2.15",
    "@angular/platform-browser-dynamic": "^21.2.15",
    "@angular/router": "^21.2.15",
    "@lucide/angular": "^1.7.0",
    "@nebular/auth": "^17.0.0",
    "@nebular/date-fns": "^17.0.0",
    "@nebular/eva-icons": "^17.0.0",
    "@nebular/security": "^17.0.0",
    "@nebular/theme": "^17.0.0",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@ng-idle/core": "^16.0.0",
    "@ng-select/ng-select": "^21.0.0",
    "@ngneat/until-destroy": "^10.0.0",
    "@popperjs/core": "^2.11.6",
    "bootstrap": "^5.3.8",
    "chart.js": "^4.5.1",
    "classlist.js": "1.1.20150312",
    "core-js": "^3.39.0",
    "date-fns": "^2.30.0",
    "eva-icons": "^1.1.3",
    "file-saver": "^2.0.5",
    "intl": "1.2.5",
    "intl-tel-input": "^24.7.0",
    "jspdf": "^4.2.1",
    "libphonenumber-js": "^1.11.4",
    "lodash-es": "^4.17.21",
    "nebular-icons": "1.1.0",
    "ng2-charts": "^8.0.0",
    "ngx-avatars": "1.10.2",
    "ngx-drag-drop": "^21.0.0",
    "ngx-highlightjs": "^12.0.0",
    "ngx-logger": "^5.0.12",
    "normalize.css": "8.0.1",
    "roboto-fontface": "0.10.0",
    "rxjs": "^7.8.2",
    "style-loader": "^1.3.0",
    "ts-md5": "^1.3.1",
    "tslib": "^2.8.1",
    "web-animations-js": "^2.3.2",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.14",
    "@angular-eslint/builder": "^20.7.0",
    "@angular-eslint/eslint-plugin": "20.7.0",
    "@angular-eslint/eslint-plugin-template": "20.7.0",
    "@angular-eslint/schematics": "20.7.0",
    "@angular-eslint/template-parser": "20.7.0",
    "@angular/build": "^21.2.13",
    "@angular/cli": "^21.2.13",
    "@angular/compiler-cli": "^21.2.15",
    "@angular/language-service": "21.2.15",
    "@compodoc/compodoc": "^1.2.1",
    "@cypress/schematic": "^5.0.0",
    "@fortawesome/fontawesome-free": "^6.6.0",
    "@tailwindcss/postcss": "^4.2.1",
    "@trivago/prettier-plugin-sort-imports": "^5.2.0",
    "@typescript-eslint/eslint-plugin": "8.14.0",
    "@typescript-eslint/parser": "8.14.0",
    "autoprefixer": "^10.4.27",
    "conventional-changelog-cli": "^5.0.0",
    "cypress": "15.16.0",
    "eslint": "^9.14.0",
    "husky": "^0.14.0",
    "jsdom": "^29.1.1",
    "npm-run-all2": "^9.0.1",
    "postcss": "^8.5.3",
    "prettier": "^3.6.2",
    "rimraf": "2.6.1",
    "stylelint": "^16.1.0",
    "tailwindcss": "^4.2.1",
    "ts-node": "3.2.2",
    "typescript": "^5.8.0",
    "vitest": "^4.1.8"
  },
  "overrides": {
    "ajv": "^8.18.0",
    "picomatch": "^4.0.2",
    "uuid": "^11.1.1"
  }
}
